<template>
  <div>
    <!-- TODO IMG SRC--->
    <v-img
      src="/bg.jpg"
      lazy-src="/bgload.jpg"
      aspect-ratio="2.5"
      max-height="250"
      gradient="180deg, rgba(0,222,111,0.19091386554621848) 55%, rgba(0,166,28,0.927608543417367) 90%"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="green lighten-2"
          ></v-progress-circular>
        </v-row>
      </template>
      <v-row align="end" justify="center" class="white--text pa-2 fill-height">
        <v-col
          class="mx-auto d-inline-block flex-grow-1"
          style="max-width: 1000px;"
        >
          <div class="display-2 text-uppercase font-weight-bold">
            Tietoa&nbsp;sivusta
          </div>
        </v-col>
      </v-row>
    </v-img>
    <v-row class="ma-0">
      <v-col cols="12">
        <LandingStrip
          ><h1>Tervehdys 👋!</h1>
          <p>
            Jos kiinnostaa, niin täältä löydät tietoa
            <a href="https://kotona.kiuruvesi.net">kotona.kiuruvesi.net</a
            >-sivustosta.
          </p></LandingStrip
        >
      </v-col>
      <v-col cols="12">
        <LandingStrip notop>
          <v-expansion-panels>
            <v-expansion-panel v-for="(faq, i) in faqs" :key="i">
              <v-expansion-panel-header>{{
                faq.title
              }}</v-expansion-panel-header>
              <v-expansion-panel-content
                ><span v-html="faq.text"></span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </LandingStrip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LandingStrip from './components/part/LandingStrip'

export default {
  name: 'Frontpage',
  components: {
    LandingStrip
  },
  data: () => ({
    faqs: [
      {
        title: 'Miten otan yhteyttä sivuston ylläpitoon?',
        text:
          'Kaikista helpoiten sähköpostilla kiuruvesi-kotona@tikkanen.info.<br><small>Jos vastausta ei kuulu järkevän ajan kuluessa, kirjoita sähköpostia vili@tikkanen.info.</small>'
      },
      {
        title: 'Miten voin ilmoittaa yritykseni sivulle?',
        text:
          "Ilmoittaminen on maksutonta. Klikkaa <a target='_blank' href='https://forms.yandex.com/u/5e764e229d2c151338ddecdf/'>tästä</a> ja täytä lomake :)"
      },
      {
        title: 'Milloin sivusto on avattu?',
        text:
          'Sivusto avattiin 21.3.2020, ja se uudistettiin kesäkuun alussa 2020.'
      },
      {
        title: 'Käyttöehdot (Päivitetty 21.3.2020)',
        text: `(Huomautus alkuun: sivusto ei ole, muttei rajoittuen, Kiuruveden kunnan omistama tai ylläpitämä)
              Yleistä
              Verkkosivusto kotona.kiuruvesi.net (jäljempänä "sivusto")
              Ylläpitäjä vili@tikkanen.info (jäljempänä "ylläpitäjä")
              Yrityksen edustaja on henkilö, jolla on käytössään yrityksen sähköpostiosoite (jäljempänä "yrityksen edustaja")
              Verkkosivusto tarjoaa yritysten edustajille paikan ilmoittaa palveluistaan.
              Ylläpitäjä pidättää oikeuden muuttaa näitä toimitusehtoja yksipuolisella päätöksellä ilman ennakkoilmoitusta.
              Ylläpitäjä pidättää oikeuden hintojen ja toimituskulujen muutoksiin.
              Nämä ehdot ovat voimassa 21.3.2020 alkaen.
              Yrityksen edustaja voi lisätä yrityksensä sivuille sivuilla olevien ohjeiden mukaa.
              Kaikki tiedot käsitellään luottamuksellisesti. Lähetettyjä tietoja ei käytetä muuhun tarkoitukseen kuin siihen tarkoitukseen johon ne on annettu tai epärehellisyyden selvittämiseen, ellei erikseen toisin mainita.
              Ylläpitäjä voi halutessaan jättää julkaistavat tiedot julkaisematta.
              Kuka tahansa kyseessa olevan yrityksen edustaja voi tarkastaa, muokata tai poistaa yrityksen tietoja ja siihen liittyviä tietoja.
              On yrityksen edustajan vastuulla todistaa, että hänellä on käytössään yritykselle rekisteröity sähköpostiosoite.
              Yrityksen edustaja ja yrityksen tekijänoikeusmerkkien oikeuksien omistaja antaa ylläpitäjälle oikeuden käyttää yrityksen merkkejä sivustolla.
              Emme vastaa ylivoimaisen esteen aiheuttamista viivästymisistä tai viivästysten aiheuttamista välillisistä tai välittömistä haitoista.
              `
      }
    ]
  })
}
</script>
